/* eslint-disable no-undef */
document.addEventListener('DOMContentLoaded', () => {
  CKEDITOR.instances.id_content.on('focus', focusEvent => focusEvent.editor.resize('100%', '280'));
});
